import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "clock-display" }
const _hoisted_2 = { class: "clock-display-inner" }
const _hoisted_3 = { class: "clock-timer" }

import { reactive } from 'vue';
import { formatTime } from '@/utils/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClockTimerComponent',
  props: {
  useUTC: {
    type: Boolean,
    default: true
  }
},
  setup(__props) {

const props = __props



const currentTime = reactive({
  time: formatTime(new Date(), props.useUTC)
});
setInterval(() => {
  currentTime.time = formatTime(new Date(), props.useUTC);
}, 1000);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(currentTime.time), 1)
    ])
  ]))
}
}

})